interface JsonDifference {
  propertyName: string;
  oldValue: any;
  currentValue: any;
}

export const isJsonString = (str: string): boolean => {
  if (!str || typeof str !== 'string') {
    return false;
  }

  try {
    const parsed = JSON.parse(str);
    return typeof parsed === 'object' && parsed !== null;
  } catch {
    return false;
  }
};

const safeJsonParse = (str: string): any => {
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
};

const compareObjects = (oldObj: any, newObj: any, path = ''): JsonDifference[] => {
  const differences: JsonDifference[] = [];

  const allKeys = new Set([...Object.keys(oldObj || {}), ...Object.keys(newObj || {})]);

  allKeys.forEach(key => {
    const currentPath = path ? `${path}.${key}` : key;
    const oldValue = oldObj?.[key];
    const newValue = newObj?.[key];

    if (
      oldValue &&
      newValue &&
      typeof oldValue === 'object' &&
      typeof newValue === 'object' &&
      !Array.isArray(oldValue) &&
      !Array.isArray(newValue)
    ) {
      differences.push(...compareObjects(oldValue, newValue, currentPath));
    } else if (oldValue !== newValue) {
      differences.push({
        propertyName: currentPath,
        oldValue,
        currentValue: newValue,
      });
    }
  });

  return differences;
};

export const getJsonDifferences = (oldJson: string, newJson: string): JsonDifference[] => {
  const oldObj = safeJsonParse(oldJson);
  const newObj = safeJsonParse(newJson);

  if (oldObj === null || newObj === null) {
    return [];
  }

  return compareObjects(oldObj, newObj);
};

export const formatValueForDisplay = (value: any): string => {
  if (value === null || value === undefined) {
    return 'null';
  }

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }

  return String(value);
};
